import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

/** Recomputes the daily rollups of a range (at most 31 days), then refetches every report. */
export function useRollup(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (range: DayRange) => reportsApi.rollup(storeId, range),
    meta: { successMessage: 'reports:toasts.refreshed' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: reportKeys.all(storeId) }),
  });
}
